// extracted by mini-css-extract-plugin
export default {"closeIcon":"CreateCaseForm_closeIcon__pIUFm","btn":"CreateCaseForm_btn__vQ-hD","btnIcon":"CreateCaseForm_btnIcon__2PjfF"};